import { AnimatePresence, motion } from 'framer-motion'
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { FaCaretUp, FaCaretDown } from 'react-icons/fa'
import Text from '../../core/utils/Text'
import useClickOutside from '../../core/hooks/useClickOutside'
import { SOCKET_URL } from '../../core/constants/urls'
import { useMainContext } from '../../core/contexts/main'
import { formatNumber } from '../../core/utils/common'

const FilterTab = forwardRef((props, ref) => {
    const {
        options,
        defaultOption,
        onOptionChanged,
        icon,
        activeTab = null,
        width = null,
        height = null,
        isCoin = false,
        margin = null,
        rFontSize = null,
        type = null,
    } = props

    const {
        main: { theme },
    } = useMainContext()

    const [selectedOption, setSelectedOption] = useState(null)

    useImperativeHandle(ref, () => ({
        reset() {
            setSelectedOption(defaultOption)
        },
    }))

    useEffect(() => {
        setSelectedOption(typeof defaultOption === 'number' ? defaultOption : options.indexOf(defaultOption))
    }, [defaultOption, options])

    useEffect(() => {
        if (activeTab !== null) {
            setSelectedOption(typeof defaultOption === 'number' ? defaultOption : options.indexOf(defaultOption))
        }
    }, [activeTab])

    const onTabClicked = (idx) => {
        onOptionChanged(idx)
        setSelectedOption(idx)
    }

    return (
        <Body>
            <Flex>
                {options.map((option, idx) => {
                    const isActive = idx === selectedOption
                    return (
                        <Option
                            active={isActive}
                            key={isCoin ? option.id : option}
                            onClick={() => onTabClicked(idx)}
                        >
                            <Text tid={option} />
                        </Option>
                    )
                })}
            </Flex>
        </Body>
    )
})

const Body = styled.div`
    min-width: 160px;
    margin: ${(props) => props.margin || '0'};
    width: ${(props) => props.width || 'fit-content'};
    height: 38px;
    border-radius: 8px;
    padding: 8px;
    background-color: ${(props) => props.theme.tInputBg};
    display: flex;
    justify-content: space-between;
    position: relative;

    @media screen and (max-width: 768px) {
		width: 100%;
	}

    @media screen and (max-width: 480px) {
        margin: 0 4px;
    }
`


const Option = styled.div`
    color: ${(props) => props.theme.color};
    font-size: 0.8rem;
    display: flex;
    justify-content: center;
    padding: 4px 6px;
    align-items: center;
    border-radius: 8px;
    width: 100%;
    background-color: ${(props) => props.active ? props.theme.mainOrange : ""};
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        opacity: 70%;
    }

    @media screen and (max-width: 768px) {
        font-size: ${(props) => props.fontSize || '0.8rem'};
    }

    @media screen and (max-width: 480px) {
        font-size: ${(props) => props.fontSize || '0.7rem'};
    }
`


const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 5px 0;
    transition: all 0.3s;
    gap: 12px;
    width: 100%;
    /* flex-wrap: wrap; */

`

export default FilterTab
